import { Container } from "inversify";
import { IoCTypes } from "./IoCTypes";
import { FacilityListService } from "@/services/facility/facility-list/FacilityListService";
import { IFacilityListService } from "@/services/facility/facility-list/IFacilityListService";
import { bindLookupStoreService } from "./LookupIoC";

export function bindFacilityListService(container: Container) {
  container.bind<IFacilityListService>(IoCTypes.FacilityListService).to(FacilityListService)
  bindLookupStoreService(container);
}